import { createActions } from 'redux-actions';

import { ACTION_PREFIX, actionTypes } from './constants';
import { getActionOptions } from '../../lib/reduxActionsUtils';
import paymentsApi from '../../api/paymentsApi';
import { Dispatch } from 'react';

export const {
  getAccountsPending,
  getAccountsFulfilled,
  getAccountsRejected,
  getSupplierBuyerAssociationPending,
  getSupplierBuyerAssociationFulfilled,
  getSupplierBuyerAssociationRejected,
  setSelectedAccount,
} = createActions(
  actionTypes.GET_ACCOUNTS_PENDING,
  actionTypes.GET_ACCOUNTS_FULFILLED,
  actionTypes.GET_ACCOUNTS_REJECTED,
  actionTypes.GET_SUPPLIER_BUYER_ASSOCIATION_PENDING,
  actionTypes.GET_SUPPLIER_BUYER_ASSOCIATION_FULFILLED,
  actionTypes.GET_SUPPLIER_BUYER_ASSOCIATION_REJECTED,
  actionTypes.SET_SELECTED_ACCOUNT,
  getActionOptions(ACTION_PREFIX)
);

const getAccounts = (checkOutId: string) => (dispatch: Dispatch<any>) => {
  dispatch(getAccountsPending());

  return paymentsApi
    .getAccounts(checkOutId)
    .then((response) => {
      return dispatch(getAccountsFulfilled(response));
    })
    .catch((error) => {
      return dispatch(getAccountsRejected(error));
    });
};

const getSupplierBuyerAssociation = (checkOutId: string, buyerAccountId: string) => (dispatch: Dispatch<any>) => {
  dispatch(getSupplierBuyerAssociationPending());

  return paymentsApi
    .getSupplierBuyerAssociation(checkOutId, buyerAccountId)
    .then((response) => {
      return dispatch(getSupplierBuyerAssociationFulfilled(response));
    })
    .catch((error) => {
      return dispatch(getSupplierBuyerAssociationRejected(error));
    });
};

export default {
  getAccounts,
  getSupplierBuyerAssociation,
  setSelectedAccount,
};
